import styles from "@app/layouts/ContentHub/contenthub.module.css";
import { configTeaser } from "@pub/config";
import placeholders from "@pub/placeholders";
import { AnchorBlock, LatestArticle } from "@sphtech/dmg-design-system";
import { ContentHubData } from "@src/app/types/ServerCustomContext";
import { GA5_REF_CODE_CONTENTHUB_ANCHOR } from "@src/app/utils/ga/ref-code";
import { buildUrlWithGARefCode } from "@src/app/utils/ga/tracking";
import cx from "classnames";
import { ReactNode } from "react";

import customStyle from "../custom.module.css";
import femaleStyle from "./femaleContenthub.module.css";
type Props = {
  data: Omit<ContentHubData, "metaData">;
  from?: number;
  limit?: number;
  firstItemAnchorBlock?: boolean;
  isListing?: boolean;
};

export default function ContentHubMasonary({
  data,
  from = 0,
  limit = 7,
  isListing = false,
}: Props) {
  const topStories =
    !isListing && data.topStories
      ? data.topStories.slice(from, limit)
      : data.listedStories;

  if (!topStories?.[0]) {
    return null;
  }

  const StoryColumn = topStories.slice(isListing ? 0 : 1).reduce<ReactNode[][]>(
    (acc, teaser, index: number) => {
      const columnIndex = index % 3;

      const itemComponent = (
        <div
          key={index}
          className={cx(styles.contentBlockItem, femaleStyle.contentBlockItem)}
        >
          <LatestArticle
            {...teaser}
            mode="original"
            placeholders={placeholders}
          />
        </div>
      );

      if (acc[columnIndex]) {
        acc[columnIndex].push(itemComponent);
      }
      return acc;
    },
    [[], [], []],
  );

  return (
    <section
      className={cx(
        styles.bodyContainer,
        styles.contenthubLatestStories,
        styles.contentBlockB,
        femaleStyle.contentBlockMasonaryContainer,
      )}
    >
      {!isListing && (
        <div
          className={cx(
            styles.latestArticleContainer,
            customStyle.anchorBlockText,
          )}
        >
          <AnchorBlock
            {...{
              ...topStories[0],
              path: buildUrlWithGARefCode(
                topStories[0].path,
                GA5_REF_CODE_CONTENTHUB_ANCHOR,
              ),
            }}
            displayPublishDate={configTeaser.publishDate}
            mobileCrop={configTeaser.anchorBlock?.mobileCrop}
          />
        </div>
      )}

      <div
        className={cx(styles.gutterHorizontal, styles.contentBlockContainer)}
      >
        <div
          className={cx(
            styles.contentBlockLayout,
            femaleStyle.contentBlockLayout,
          )}
        >
          {StoryColumn.map((column, index) => (
            <div key={index} className={cx(femaleStyle[`flow${index + 1}`])}>
              {column}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
